export enum ComponentFailureVariant {
  inline,
  spaceBetween
}

export const DefaultComponentContent = {
  headingText: 'Element failed to load',
  bodyText: `Please reload the page. If the issue persists, please contact <a href='/company/contact-us'>customer service</a>.`,
  buttonText: 'Try again',
  variant: ComponentFailureVariant.inline
};
